import waves from './waves'

export default {
  install (Vue) {
    Vue.directive('waves', waves)
  }
}



// WEBPACK FOOTER //
// ./src/directive/waves/index.js